// extracted by mini-css-extract-plugin
export default {"progressWrap":"ProgressCircle_progressWrap__c0yn1"};